import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: '#183f64',
                secondary: '#0f9732',
                anchor: '#0f9732',
                lightBlue: '#22598d',
                lighterBlue: '#26619c',
            },
        },
    },
});
